import { useEffect, useState } from "react";
import styles from "./App.module.scss";

import Game from "../Game";

const MIN_VIEWPORT_WIDTH = 720;
const MIN_VIEWPORT_HEIGHT = 480;

function App() {
  const [isSmallViewport, setIsSmallViewport] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return (
      window.innerWidth < MIN_VIEWPORT_WIDTH ||
      window.innerHeight < MIN_VIEWPORT_HEIGHT
    );
  });

  useEffect(() => {
    const handleViewportChange = () => {
      setIsSmallViewport(
        window.innerWidth < MIN_VIEWPORT_WIDTH ||
          window.innerHeight < MIN_VIEWPORT_HEIGHT
      );
    };

    handleViewportChange();
    window.addEventListener("resize", handleViewportChange);

    return () => window.removeEventListener("resize", handleViewportChange);
  }, []);

  return (
    <div className={styles.app}>
      {isSmallViewport ? (
        <section className={styles.disclaimer} aria-live="polite">
          <p className={styles.eyebrow}>Desktop only</p>
          <h1>This game is not available on small screens.</h1>
          <p className={styles.message}>
            Please open the app on a desktop or enlarge your browser window to
            continue.
          </p>
        </section>
      ) : (
        <Game />
      )}
    </div>
  );
}

export default App;
